import React from "react";
import { Box, Text, TextArea } from "@showitinc/showit-wc";

import AssetSelectInput from "../shared/AssetSelectInput";
import { initFormatter } from "../../../utils/PropertyFormatters";
import styles from "./PagePropertiesSEO.module.css";

const PagePropertiesSEO = ({ onPropUpdate, page }) => {
  const { onChange } = initFormatter(onPropUpdate);

  const title = page.getIn(["meta", "title"], "");
  const desc = page.getIn(["meta", "desc"], "");
  const image = page.getIn(["meta", "image"]);

  return (
    <>
      <TextArea
        label="Page Title"
        onSIBeforeChange={onChange("meta.title", title)}
        onSIInput={onChange("meta.title", title, false)}
        value={title}
        className={styles["page-title-textarea"]}
        resize
      >
        <Box
          slot="label"
          d="flex"
          justify="between"
          className={styles["spacing-between-text-box-and-textarea"]}
        >
          <Text className={styles["page-title"]}>Page Title</Text>
          <Text className={`${title.length > 60 ? styles["page-count-error"] : null}`}>{title.length}/60</Text>
        </Box>
      </TextArea>
      <TextArea
        label="Meta Description"
        onSIBeforeChange={onChange("meta.desc", desc)}
        onSIInput={onChange("meta.desc", desc, false)}
        value={desc}
        resize
      />
      <AssetSelectInput
        label="Share Image"
        helpTooltip="seo-share-image"
        selectLabel="Choose Image"
        propName="meta.image"
        extensionFilter={["png", "jpg", "jpeg"]}
        value={image}
        enableDelete
        onChange={onPropUpdate}
        longLabel
      />
    </>
  );
};

export default PagePropertiesSEO;
